export default "/images/4f4f56a2e00d24ea5be5d6578aa01983.avif";